var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgSortArrows = function SvgSortArrows(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sort-arrow-up",
    d: "M7 -6.11959e-07L0.937823 5.25L13.0622 5.25L7 -6.11959e-07Z",
    fill: "#0D0E10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "sort-arrow-down",
    d: "M7 13L0.937823 7.75L13.0622 7.75L7 13Z",
    fill: "#A9B2BD"
  })));
};
var Memo = /*#__PURE__*/memo(SvgSortArrows);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/SortArrows.66baf28bb1533c5194d02cae7700f1bb.svg";